import { Injectable, inject, signal } from '@angular/core';

import { CorrectScoreHeaderButtonTabs } from '@frontend/sports/betting-offer/feature/model';
import { EventDetailsConfig } from '@frontend/sports/common/client-config-data-access';

@Injectable({ providedIn: 'root' })
export class CorrectScoreOptionGroupToggleViewService {
    private eventDetailsConfig = inject(EventDetailsConfig);

    currentViewId = signal<string>(
        this.eventDetailsConfig.enableCorrectScoreOptionGroupToggle
            ? CorrectScoreHeaderButtonTabs.CorrectScoreCompactView
            : CorrectScoreHeaderButtonTabs.CorrectScoreRegularView,
    );

    setCorrectScoreView(id: string): void {
        this.currentViewId.set(id);
    }
}
